import { useTranslation } from "react-i18next";
import "../assets/css/contact.css";
import contactInfo from "../assets/data/contactInfo.json";

const Contact = () => {
    const { t } = useTranslation();

    return (
        <>
            <div className="contact" id="contact">
                <div className="head">
                    <h1>{t("contact.title")}</h1>
                    <h4>{t("contact.subtitle")}</h4>
                    <hr />
                </div>

                <div className="contact-head">
                    <div className="sec first">
                        {contactInfo.map((item, index) => (
                            <div key={index}>
                                <div className="inline">
                                    <i className={item.icon}></i>
                                    <h5>{t(item.titleKey)}</h5>
                                </div>
                                {t(item.detailsKey, {
                                    returnObjects: true,
                                }).map((detail, idx) => (
                                    <p key={idx}>{detail}</p>
                                ))}
                                {index < contactInfo.length - 1 && <hr />}
                            </div>
                        ))}
                    </div>

                    <div className="sec second">
                        <iframe
                            title={t("contact.mapTitle")}
                            frameBorder="0"
                            scrolling="no"
                            marginHeight="0"
                            marginWidth="0"
                            src="https://maps.google.com/maps?width=300&amp;height=600&amp;hl=en&amp;q=86%20Boulevard%20Eug%C3%A8ne%20R%C3%A9guillon+(Jordan%20Web%20Studio)&amp;t=&amp;z=6&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                        >
                            <a href="https://www.gps.ie/">gps tracker sport</a>
                        </iframe>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Contact;
